// 🔋 Polyfills
// https://www.carbondesignsystem.com/getting-started/developers/vanilla#polyfills-for-older-browsers

/* eslint-disable import/no-extraneous-dependencies */
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.math.sign';
import 'core-js/modules/es6.object.assign';
/* eslint-enable import/no-extraneous-dependencies */

import 'picturefill';

import './custom-event';
import './element-closest';
import './element-matches';
import './toggle-class';
